 <section id="container" [ngClass]="{'sidebar-closed': sideNavService.hideSideNav }">
  <!--header start-->
  <app-header></app-header>
  <!--header end-->
  <!--sidebar start-->
  <app-sidemenu></app-sidemenu>
  <!--sidebar end-->
  <!--main content start-->
  <section id="main-content">
    <section class="wrapper">
      <!-- page start-->
      <div class="row">
        <div class="col-lg-12">
          <ul class="breadcrumb">
            <li><a href="/"><i class="fa fa-home"></i> Home</a></li>
            <li><a href="javascript:void(0);" style="cursor: default;">{{orderHeading}}</a></li>
          </ul>

        </div>
      </div>

      <form class="form-horizontal" #ngForm="ngForm" [formGroup]="orderForm" (ngSubmit)="ordersubmit()">                    
        <div class="row">
          <div class="col-sm-12">
           <!--collapse start-->
           <div class="panel-group m-bot20" id="accordion">
            <div class="panel panel-default">

              <div class="panel-heading">
                <h4 class="panel-title">
                  <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
                    Customer Information <!-- <i class="more-less glyphicon glyphicon-plus"></i> -->
                  </a>
                </h4>
              </div>

              <div id="collapseOne" class="panel-collapse collapse in">
                <div class="panel-body">
                  <div class="alert alert-success fade in" *ngIf="is_order_responded && is_order_responded_success">
                    <button data-dismiss="alert" class="close close-sm" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                    Order added and an email has been sent successfully. Please check your email for further process.
                  </div>

                  <div class="alert alert-block alert-danger fade in " *ngIf="is_order_responded && is_order_responded_failed">
                    <button data-dismiss="alert" class="close close-sm" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                    Something Went Wrong. Please Try Again.
                  </div>

                  <input type="hidden"  class="form-control" formControlName="order_number" >
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name" class="col-sm-3 control-label">Name <span class="red">*</span></label>
                      <div class="col-sm-9">
                        <input type="text" class="form-control" formControlName="name" placeholder="Name" />
                        <p class="error-block" *ngIf="orderForm.get('name').invalid && (orderForm.get('name').dirty || ngForm.submitted)"><span *ngIf="orderForm.controls['name'].errors.required">Please Enter Name</span></p>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="company_name" class="col-sm-3 control-label">Company Name <span class="red">*</span></label>
                      <div class="col-sm-9">
                        <input type="text"  class="form-control" formControlName="company_name" placeholder="Company Name">

                        <p class="error-block" *ngIf="orderForm.get('company_name').invalid && (orderForm.get('company_name').dirty  || ngForm.submitted)"><span *ngIf="orderForm.controls['company_name'].errors.required">Please Enter Company Name</span></p>
                      </div>
                    </div>
                    <div class="form-group">
                     <label for="billing_address" class="col-sm-3 control-label">Billing Address</label>
                     <div class="col-sm-9">
                      <textarea style="width:100%" class="form-control" formControlName="billing_address"> </textarea>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="billing_city" class="col-sm-3 control-label">Billing City</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" formControlName="billing_city" placeholder="Billing City">
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="state" class="col-sm-3 control-label">State/ Province</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" formControlName="state" placeholder="State/ Province">
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="country" class="col-sm-3 control-label">Country</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" formControlName="country" placeholder="Country">
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="zipcode" class="col-sm-3 control-label">Zipcode</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" formControlName="zipcode" placeholder="Zipcode">
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="telephone" class="col-sm-3 control-label">Telephone <span class="red">*</span></label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" formControlName="telephone" placeholder="Telephone">
                      <p class="error-block" *ngIf="orderForm.get('telephone').invalid && (orderForm.get('telephone').dirty  || ngForm.submitted)"><span *ngIf="orderForm.controls['telephone'].errors.required || orderForm.controls['telephone'].errors.minlength">Please Enter A Valid Telephone</span></p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="email" class="col-sm-3 control-label">Client Email <span class="red">*</span></label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" formControlName="email" placeholder="Client Email">
                      <p class="error-block" *ngIf="orderForm.get('email').invalid && (orderForm.get('email').dirty  || ngForm.submitted)"><span *ngIf="orderForm.controls['email'].errors.required || orderForm.controls['email'].errors.email">Please Enter A Valid Email</span></p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="url" class="col-sm-3 control-label">Url <span class="red">*</span></label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" formControlName="url" placeholder="Url">
                      <p class="error-block" *ngIf="orderForm.get('url').invalid && (orderForm.get('url').dirty  || ngForm.submitted)"><span *ngIf="orderForm.controls['url'].errors.required">Please Enter Url</span></p>
                    </div>
                  </div>


                  <div class="form-group" style="margin-bottom: 0;">
                    <div class="orderdatecontainer">
                      <label for="created_date" class="col-sm-3 control-label">Date <span class="red">*</span></label>
                      <div class="col-sm-9 datecontainer">
                        <mat-form-field appearance="fill">
                          <mat-label>Choose a date</mat-label>
                          <input class="form-control datepicker" formControlName="created_date" matInput [matDatepicker]="picker">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker ></mat-datepicker>
                        </mat-form-field>
                        <p class="error-block" *ngIf="orderForm.get('created_date').invalid && (orderForm.get('created_date').dirty  || ngForm.submitted)"><span *ngIf="orderForm.controls['created_date'].errors.required">Please Enter A Date</span></p>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="seo_consultant" class="col-sm-3 control-label">Sales Rep <span class="red">*</span></label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" formControlName="seo_consultant" placeholder="Sales Rep">
                      <p class="error-block" *ngIf="orderForm.get('seo_consultant').invalid && (orderForm.get('seo_consultant').dirty  || ngForm.submitted)"><span *ngIf="orderForm.controls['seo_consultant'].errors.required">Please Enter Sales Rep</span></p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="seo_consultant_email" class="col-sm-3 control-label">Sales Rep Email <span class="red">*</span></label>
                    <div class="col-sm-9">
                      <input type="email" class="form-control" formControlName="seo_consultant_email" placeholder="Sales Rep Email">
                      <p class="error-block" *ngIf="orderForm.get('seo_consultant_email').invalid && (orderForm.get('seo_consultant_email').dirty  || ngForm.submitted)"><span *ngIf="orderForm.controls['seo_consultant_email'].errors.required || orderForm.controls['seo_consultant_email'].errors.email">Please Enter  A Valid Email</span></p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="dialer" class="col-sm-3 control-label">Dialer </label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" formControlName="dialer" placeholder="Dialer">

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="panel panel-default">

            <div class="panel-heading">
              <h4 class="panel-title">
                <a [ngClass]="{'disabled': !orderForm.valid}"  class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">
                  Service & Fee Summary
                  <!-- <i class="more-less glyphicon glyphicon-plus"></i> -->
                </a>
              </h4>
            </div>

            <div id="collapseTwo" class="panel-collapse collapse in">
              <div class="panel-body">
                  <section id="no-more-tables">

                    <table class="table  table-striped table-condensed cf">
                      <thead class="cf">
                        <tr>
                          <th>Description</th>
                          <th style="width:20%">Quantity</th>
                          <th style="text-align:center">Price</th>
                          <th style="text-align:center;width:20%">Time</th>

                        </tr>
                      </thead>
                      <tbody>
                        <ng-container formArrayName="items">
                          <tr *ngFor="let item of orderForm.get('items')['controls']; let i = index;" [formGroupName]="i">

                            <td data-title="Code">
                             
                              <select id="product_desc_{{i}}" (change)="changeProduct($event)" *ngIf="product_types[i]=='select'" formControlName="name" class="form-control m-bot15">
                                <option value="">Select Product</option>
                                <option *ngFor="let pitem of pData" value="{{pitem.id}}">{{pitem.product_name}}</option>
                              </select>
                              <textarea *ngIf="product_types[i]=='text'" formControlName="name" rows=10  class="form-control customproduct" ></textarea>
                              <div [innerHTML]="product_desc[i]"></div>
                            </td>
                            <td data-title="Company"><div id="spinner1">
                              <div class="input-group input-small">
                                <input formControlName="quantity" type="text" class="spinner-input form-control" maxlength="3" >
                                <div class="spinner-buttons input-group-btn btn-group-vertical">
                                  <button type="button" (click)="increment(i);" class="btn spinner-up btn-xs btn-default">
                                    <i class="fa fa-angle-up"></i>
                                  </button>
                                  <button type="button" (click)="decrement(i);" class="btn spinner-down btn-xs btn-default">
                                    <i class="fa fa-angle-down"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td  data-title="Price" style="text-align:center"><input (keyup)="calculate_total()" formControlName="price" style="width:50%;" type="text" class="form-control"  placeholder="Enter Price"></td>
                          <td  data-title="Price">
                            <select (change)="calculate_total()" formControlName="time_type" style="width: 60%;float: left;" class="form-control m-bot15">
                              <option value="Monthly" selected="selected">Monthly</option>
                              <option value="One Time">One Time</option>
                            </select>
                            <button   style=" float: left; margin-left: 10px; margin-top: 5px;" class="btn btn-primary  btn-xs" (click)="removeItem(i);"><i class="fa fa-trash-o"></i></button>
                          </td>
                        </tr>
                      </ng-container>
                      <tr>
                        <td><button type="button"  class="btn btn-primary" (click)="addItem();" >Add Product</button></td>
                        <td ><button type="button"  class="btn btn-primary"  (click)="addCustomItem();" >Add Custom Product</button></td>
                        <td  data-title="Total monthly payment" style="text-align:center">Total monthly payment</td>
                        <td ><input readonly="readonly"  formControlName="tot_month_pay" style="width:60%;" type="text" class="form-control"  placeholder=""></td>

                      </tr>
                      <tr>
                        <td> </td>
                        <td ></td>
                        <td  data-title="Total One Time payment" style="text-align:center">Total One Time payment</td>
                        <td ><input readonly="readonly" formControlName="tot_one_pay" style="width:60%;" type="text" class="form-control"  placeholder=""></td>

                      </tr>
                      <tr>
                        <td> </td>
                        <td ></td>
                        <td  data-title="Grand Total" style="text-align:center">Grand Total</td>
                        <td ><input readonly="readonly" formControlName="grand_total" style="width:60%;" type="text" class="form-control"  placeholder=""></td>

                      </tr>
                    </tbody>
                  </table>


                </section>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="term" class="col-sm-3 control-label">Terms </label>
                    <div class="col-sm-9">
                     <select formControlName="term" class="form-control">
                      <option value="One Time">One Time</option> 
                      <!-- <option value="One Time with a Monthly Term">One Time with a Monthly Term</option> -->                                    
                      <option value="Month to Month" selected="selected">Month to Month</option>
                      <option value="3 Month Term">3 Month</option>
                      <option value="4 Month Term">4 Month</option>
                      <option value="6 Month Term">6 Month</option>
                      <option value="12 Month Term">12 Month</option>
                      <option value="One Time with Month to Month">One Time with Month to Month</option>
                      <option value="One Time with 3 Months">One Time with 3 Months</option>
                      <option value="One Time with 4 Months">One Time with 4 Months</option>
                      <option value="One Time with 6 Months">One Time with 6 Months</option>
                      <option value="One Time with 12 Months">One Time with 12 Months</option>

                    </select>
                    <p class="error-block" *ngIf="orderForm.get('term').invalid && (orderForm.get('term').dirty  || ngForm.submitted)"><span *ngIf="orderForm.controls['term'].errors.required">Please Enter  Terms</span></p>
                  </div>
                </div>
                <div class="form-group">
                  <label for="payment_mode_ids" class="col-sm-3 control-label">Modes of payment</label>
                  <div class="col-sm-9">
                    <select formControlName="payment_mode_ids"  class="form-control">
                      <option value="0">Select Payment Mode</option>
                      <option value="1">Check</option>
                      <option value="2" selected="selected">Credit Card</option>
                      <option value="3">Wire Transfer</option>
                      <option value="4">Paypal</option>
                      <option value="5">Electronic Check</option>
                    </select>

                    <p class="error-block" *ngIf="orderForm.get('payment_mode_ids').invalid && (orderForm.get('payment_mode_ids').dirty  || ngForm.submitted)"><span *ngIf="orderForm.controls['payment_mode_ids'].errors.required">Please Enter Modes of payment</span></p>
                  </div>
                </div>
                <div class="form-group">
                 <label for="note" class="col-sm-3 control-label">Note</label>
                 <div class="col-sm-9">
                  <textarea style="width:100%" class="form-control" formControlName="note" rows=10> </textarea>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <div class="col-lg-10">
                  <button type="submit" class="btn btn-primary">Submit</button>
                  <p class="error-block" *ngIf="is_order_submitted && !orderForm.valid && items.length"><span>One or more fields contain errors </span></p>
                   <p class="error-block" *ngIf="is_order_submitted && orderForm.valid && items.length==0"><span>You must select at least one product </span></p>
                </div>
              </div>
              <div *ngIf="is_order_loading" class="d-flex justify-content-center">
                <div class="spinner-border m-5" style="color:#c02429" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>


          </div>

        </div>
      </div>

    </div>

  <!--collapse end-->

</div>

</div>
</form>
<!-- page end-->
</section>
</section>
<!--main content end-->
<!-- Right Slidebar start -->

<!-- Right Slidebar end -->
<!--footer start-->
<app-footer></app-footer>
<!--footer end-->
</section>